import * as auth from './auth'
import * as system from './system'
import * as user from './user'
import * as task from './task'
import * as calendarEvent from './calendarEvent'
import * as coach from './coach'
import * as patient from './patient'
import * as note from './note'
import * as checklist from './checklist'
import * as upload from './upload'
import * as event from './event'
import * as msk from './msk'
import * as alerts from './alerts'
import * as auditTrail from './auditTrail'
import * as chat from './chat'
import * as clinic from './clinic'
import * as notifications from './notifications'
import * as chart from './chart'
import * as subscription from './subscription'
import * as organization from './organization'

export default {
	auth,
	system,
	user,
	task,
	calendarEvent,
	coach,
	patient,
	note,
	checklist,
	upload,
	event,
	msk,
	alerts,
	auditTrail,
	chat,
	clinic,
	notifications,
	chart,
	subscription,
	organization,
}
